module.exports = __webpack_public_path__ + "img/riba-icon.e30c9aa0.png";